import Api from 'Helpers/api';

const Furnitures = {
	get: async () => {
		const response = await Api.call('get', '/furnitures');
		return response.data;
	},
	create: async params => {
		const response = await Api.call('post', '/furnitures', params);
		return response.data;
	}
};

export default Furnitures;
